export const semanticTokens = {
	colors: {
		text: {
			default: {
				default: 'gray.900',
				_dark: 'gray.100',
			},
			soft: {
				default: 'gray.700',
				_dark: 'gray.200',
			},
			softer: {
				default: 'gray.600',
				_dark: 'gray.300',
			},
			softest: {
				default: 'gray.500',
				_dark: 'gray.400',
			},
			onColor: {
				default: 'white',
				_dark: 'gray.25',
			},
			interactive: {
				default: 'blue.500',
				_dark: 'blue.300',
			},
			hashtag: {
				default: 'purple.500',
				_dark: 'purple.300',
			},
			disabled: {
				default: '#a6acb5ff',
				_dark: '#656c7bff',
			},
		},
		bizy: {
			outline: {
				default: '#051236',
				_dark: 'gray.400',
			},
		},
		bg: {
			canvas: {
				default: 'gray.25',
				_dark: 'gray.800',
			},
			surface: {
				default: 'white',
				_dark: 'gray.900',
			},
			menu: {
				default: 'white',
				_dark: 'gray.800',
			},
			inset: {
				default: 'gray.25',
				_dark: 'gray.800',
			},
			soft: {
				default: 'gray.100',
				_dark: 'gray.800',
			},
			subtle: {
				default: 'gray.50',
				_dark: 'black',
			},
			disabled: {
				default: 'grayAlpha.50',
				_dark: 'grayAlpha.100',
			},
			topNav: {
				default: 'whiteAlpha.1000',
				_dark: 'gray.900',
			},
			overlayBackdrop: {
				default: 'blackAlpha.500',
				_dark: 'blackAlpha.900',
			},
			carouselFade: {
				default: 'gray.50',
				_dark: 'black',
			},
			minipage: {
				default: 'whiteAlpha.900',
				_dark: 'blackAlpha.900',
			},
			marketing: {
				default: '#051236',
				_dark: '#051236',
			},
		},
		primary: {
			fg: {
				default: 'blue.500',
				_dark: 'blue.50',
			},
			fgStrong: {
				default: 'blue.600',
				_dark: 'blue.300',
			},
			fgStronger: {
				default: 'blue.700',
				_dark: 'blue.200',
			},
			fgStrongest: {
				default: 'blue.800',
				_dark: 'blue.300',
			},
			bgAlpha: {
				default: 'blueAlpha.100',
				_dark: 'blueAlpha.200',
			},
			bgAlphaHover: {
				default: 'blueAlpha.200',
				_dark: 'blueAlpha.300',
			},
			bgAlphaActive: {
				default: 'blueAlpha.300',
				_dark: 'blueAlpha.300',
			},
			bg: {
				default: 'blue.500',
				_dark: 'blue.500',
			},
			bgHover: {
				default: 'blue.600',
				_dark: 'blue.600',
			},
			bgActive: {
				default: 'blue.700',
				_dark: 'blue.700',
			},
		},
		secondary: {
			fg: {
				default: 'gray.800',
				_dark: 'gray.50',
			},
			fgActive: {
				default: 'gray.900',
				_dark: 'gray.25',
			},
			fgOnSurface: {
				default: 'white',
				_dark: 'gray.900',
			},
			bg: {
				default: 'gray.900',
				_dark: 'gray.50',
			},
			bgHover: {
				default: 'gray.700',
				_dark: 'gray.100',
			},
			bgActive: {
				default: 'gray.600',
				_dark: 'gray.200',
			},
			bgAlpha: {
				default: 'grayAlpha.100',
				_dark: 'grayAlpha.200',
			},
			bgAlphaHover: {
				default: 'grayAlpha.200',
				_dark: 'grayAlpha.300',
			},
			bgAlphaActive: {
				default: 'grayAlpha.300',
				_dark: 'grayAlpha.400',
			},
		},
		points: {
			fg: {
				default: 'green.600',
				_dark: 'green.300',
			},
			fgHover: {
				default: 'green.700',
				_dark: 'green.200',
			},
			fgOnSurface: {
				default: 'green.500',
				_dark: 'green.400',
			},
			bgAlpha: {
				default: 'greenAlpha.100',
				_dark: 'greenAlpha.100',
			},
			bgAlphaHover: {
				default: 'greenAlpha.200',
				_dark: 'greenAlpha.200',
			},
			bgAlphaActive: {
				default: 'greenAlpha.300',
				_dark: 'greenAlpha.300',
			},
		},
		hashtag: {
			fgOnSurface: {
				default: 'purple.500',
				_dark: 'purple.400',
			},
			fg: {
				default: 'purple.600',
				_dark: 'purple.400',
			},
			fgHover: {
				default: 'purple.700',
				_dark: 'purple.400',
			},
			bgAlpha: {
				default: 'purpleAlpha.100',
				_dark: 'purpleAlpha.200',
			},
			bgAlphaHover: {
				default: 'purpleAlpha.200',
				_dark: 'purpleAlpha.300',
			},
			bgAlphaActive: {
				default: 'purpleAlpha.300',
				_dark: 'purpleAlpha.400',
			},
		},
		ai: {
			'text-underline': {
				default: 'purpleAlpha.500',
				_dark: 'purpleAlpha.500',
			},
		},
		danger: {
			fg: {
				default: 'red.500',
			},
			fgStrong: {
				default: 'red.600',
			},
			fgStronger: {
				default: 'red.700',
			},
			fgStrongest: {
				default: 'red.800',
			},
			bgAlpha: {
				default: 'redAlpha.100',
			},
			bgAlphaHover: {
				default: 'redAlpha.200',
			},
			bgAlphaActive: {
				default: 'redAlpha.300',
			},
			bg: {
				default: 'red.500',
			},
			bgHover: {
				default: 'red.600',
			},
			bgActive: {
				default: 'red.700',
			},
		},
		border: {
			default: {
				default: 'grayAlpha.300',
				_dark: 'grayAlpha.300',
			},
			soft: {
				default: 'grayAlpha.200',
				_dark: 'grayAlpha.200',
			},
			strong: {
				default: 'grayAlpha.500',
				_dark: 'grayAlpha.400',
			},
			focus: {
				default: 'blue.500',
				_dark: 'blue.500',
			},
			input: {
				default: 'gray.500',
				_dark: 'gray.500',
			},
			onOverlay: {
				default: 'grayAlpha.300',
				_dark: 'grayAlpha.500',
			},
		},
		success: {
			text: {
				default: 'green.600',
				_dark: 'green.300',
			},
			bg: {
				default: 'green.50',
				_dark: 'green.900',
			},
			closeBg: {
				default: 'greenAlpha.100',
				_dark: 'green.800',
			},
			closeBgHover: {
				default: 'greenAlpha.200',
				_dark: 'green.700',
			},
			closeBgActive: {
				default: 'greenAlpha.300',
				_dark: 'green.700',
			},
			icon: {
				default: 'green.500',
				_dark: 'green.400',
			},
			datavizMid: {
				default: 'green.400',
				_dark: 'green.400',
			},
		},
		error: {
			text: {
				default: 'red.600',
				_dark: 'red.300',
			},
			bg: {
				default: 'red.50',
				_dark: 'red.900',
			},
			closeBg: {
				default: 'redAlpha.100',
				_dark: 'red.800',
			},
			closeBgHover: {
				default: 'redAlpha.200',
				_dark: 'red.700',
			},
			closeBgActive: {
				default: 'redAlpha.300',
				_dark: 'red.700',
			},
			icon: {
				default: 'red.600',
				_dark: 'red.400',
			},
			inputBorder: {
				default: 'red.500',
				_dark: 'red.400',
			},
			inputBg: {
				default: 'red.25',
				_dark: 'red.900',
			},
			datavizMid: {
				default: 'red.400',
				_dark: 'red.400',
			},
		},
		warning: {
			text: {
				default: 'yellow.700',
				_dark: 'yellow.300',
			},
			bg: {
				default: 'yellow.25',
				_dark: 'yellow.900',
			},
			closeBg: {
				default: 'yellowAlpha.100',
				_dark: 'yellow.800',
			},
			closeBgHover: {
				default: 'yellowAlpha.100',
				_dark: 'yellow.700',
			},
			closeBgActive: {
				default: 'yellowAlpha.100',
				_dark: 'yellow.700',
			},
			icon: {
				default: 'yellow.500',
				_dark: 'yellow.400',
			},
			datavizMid: {
				default: 'yellow.400',
				_dark: 'yellow.400',
			},
		},
		info: {
			text: {
				default: 'gray.700',
				_dark: 'blue.300',
			},
			bg: {
				default: 'gray.50',
				_dark: 'blue.900',
			},
			closeBg: {
				default: 'grayAlpha.100',
				_dark: 'blue.800',
			},
			closeBgHover: {
				default: 'grayAlpha.200',
				_dark: 'blue.700',
			},
			closeBgActive: {
				default: 'grayAlpha.300',
				_dark: 'blue.700',
			},
			icon: {
				default: 'gray.400',
				_dark: 'gray.500',
			},
			datavizMid: {
				default: 'gray.400',
				_dark: 'gray.400',
			},
		},
		rewards: {
			bg: {
				default: 'white',
				_dark: 'black',
			},
		},
		scrollbar: {
			thumb: {
				default: '#0000001a',
				_dark: '#ffffff1a',
			},
			thumbHover: {
				default: '#0003',
				_dark: '#fff3',
			},
		},
		spotlightBanner: {
			fg: {
				default: 'teal.300',
				_dark: 'teal.200',
			},
			bg: {
				default: 'teal.300',
				_dark: 'teal.100',
			},
		},
	},
	shadows: {
		xs: {
			default: '#00000006 0px 3px 6px -2px, #0000000B 0px 1px 1px',
			_dark: '#00000014 0px 4px 4px -1px, #00000029 0px 1px 1px 0px',
		},
		sm: {
			default: '0 0 1px 0 #4348561a, 0 1px 1px 0 #4348560a, 0 2px 2px 0 #43485608, 0 5px 3px 0 #43485605, 0 9px 4px 0 #43485603',
			_dark: '0 0 1px 0 #00000080, 0 1px 2px 0 #00000066, 0 2px 4px 0 #00000050, 0 4px 6px 0 #00000040',
		},
		base: {
			default: '0 0 1px 0 #00000014, 0 1px 2px 0 #0000000d, 0 5px 4px 0 #0000000a, 0 11px 5px 0 #00000005, 0 19px 6px 0 #00000003',
			_dark: '0 0 1px 0 #00000080, 0 2px 4px 0 #00000066, 0 6px 8px 0 #00000050, 0 12px 10px 0 #00000040',
		},
		md: {
			default: '0 0 1px 0 #43485614, 0 2px 4px 0 #43485614, 0 9px 8px 0 #43485614, 0 21px 12px 0 #4348560a, 0 37px 14px 0 #43485603',
			_dark: '0 0 2px 0 #00000099, 0 4px 8px 0 #00000080, 0 10px 16px 0 #00000066, 0 20px 24px 0 #00000050',
		},
		lg: {
			default: '0 0 1px 0 #43485614, 0 3px 5px 0 #4348561c, 0 12px 10px 0 #4348561a, 0 26px 14px 0 #4348560d, 0 47px 18px 0 #43485605',
			_dark: '0 0 2px 0 #00000099, 0 6px 12px 0 #00000080, 0 14px 24px 0 #00000066, 0 28px 32px 0 #00000050',
		},
		xl: {
			default: '0 0 1px 0 #43485614, 0 4px 8px 0 #43485624, 0 14px 12px 0 #4348561f, 0 32px 18px 0 #4348560f, 0 56px 20px 0 #43485605',
			_dark: '0 0 2px 0 #000000b3, 0 8px 16px 0 #00000099, 0 20px 32px 0 #00000080, 0 40px 48px 0 #00000066',
		},
		'2xl': {
			default: '0 0 1px 0 #4348562e, 0 5px 10px 0 #4348562e, 0 19px 19px 0 #43485626, 0 42px 25px 0 #43485617, 0 75px 30px 0 #43485608',
			_dark: '0 0 2px 0 #000000cc, 0 10px 20px 0 #000000b3, 0 24px 40px 0 #00000099, 0 50px 60px 0 #00000080',
		},
	},
	space: {
		paragraph: {
			1: '0.5rem',
			50: '0.625rem',
			100: '0.75rem',
			150: '0.875rem',
			200: '1rem',
			300: '1.125rem',
			400: '1.375rem',
			500: '1.5rem',
			600: '1.75rem',
			700: '2rem',
			800: '2.25rem',
			900: '2.5rem',
			1000: '3rem',
			1100: '3.5rem',
			1200: '3.75rem',
		},
	},
};
